import * as React from 'react';

import { useRouterStore } from '@/store/routerStore';

export const useScrollIntoView = <T extends HTMLElement = HTMLDivElement>(id: string) => {
  const scrollTo = useRouterStore((state) => state.scrollTo);
  const resetScrollTo = useRouterStore((state) => state.resetScrollTo);

  const ref = React.useRef<T | null>(null);

  const callbackObserver = React.useCallback((_entries: unknown, observer: ResizeObserver) => {
    if (ref.current) {
      ref.current.scrollIntoView({ block: 'start', inline: 'center' });

      observer.disconnect();
    }
  }, []);

  const intersectObserver = React.useMemo(
    () => new IntersectionObserver(callbackObserver),
    [callbackObserver],
  );

  React.useEffect(() => {
    if (scrollTo && ref.current && id === scrollTo) {
      ref.current.scrollIntoView({ block: 'start', inline: 'center' });
      intersectObserver.observe(ref.current);

      resetScrollTo();
    }

    return () => {
      intersectObserver.disconnect();
    };
  }, [id, intersectObserver, resetScrollTo, scrollTo]);

  return [ref];
};
